/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".validation-msg[_ngcontent-%COMP%] {\n  margin-left: 33%; }\n\ninput[_ngcontent-%COMP%]::-webkit-calendar-picker-indicator {\n  right: 0.5em;\n  top: 0.7em;\n  position: fixed; }"];
export { styles as styles };
